/** The sequence editor's sources (1.0.0-rc.4): when their list must keep refreshing. */

/**
 * A source whose media is still on its way: recording, or not yet through processing. A recording's waveform is
 * made after its proxy, so the list keeps refreshing until processing has finished, not only until the proxy exists.
 */
export const sourceStillChanging = (s: { live?: unknown; status: string }): boolean => Boolean(s.live) || ['recording', 'registered', 'processing'].includes(s.status);
